import React from "react";

import PepsicoSvg from "../../utils/PepsicoSvg";
import "./AgHubHeader.css";

export default function AgHubHeader() {
  return (
    <header className="header w-full">
      <div className="logo">
        <PepsicoSvg />
      </div>

      <div className="text-large-screen font-bold">
        <p>Frito Lay Agriculture</p>
      </div>

      <div className="text-small-screen font-bold">
        <p>Frito Lay Agriculture</p>
      </div>
    </header>
  );
}
